module.exports = __webpack_public_path__ + "media/images/sports_icons/basketball-ee89a2b8e582822988fc6d3db2d5f5ba.png";